import styled from '@emotion/styled'

const AuthContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    @media (min-width: calc(${props => props.theme.bps.md} - 1px)) {
        margin: 0;
        padding: 0 1rem;
        border-top: none;

        justify-content: flex-end;

        a:first-of-type {
            margin-right: 0;
        }
    }

    @media (min-width: ${props => props.theme.bps.lg}) {
        padding: 0;

        &::after {
            content: '';
            border-right: 1px solid #e5e5e5;
            margin: 0 0.5rem;
        }
    }
`

const HeaderLogo = styled.div`
    padding: 1.25rem 1.5rem;

    display: flex;
    justify-content: space-between;

    @media (max-width: ${props => props.theme.bps.md}) {
        margin-left: auto;
        align-items: center;

        .logo-img-container {
            height: 2.5rem;
            width: 3.6rem;

            &.black {
                background: url('/images/easywallet/logo-easywallet.png') center/contain no-repeat;
                background-size: 3.6rem;
            }

            &.white {
                background: url('/images/easywallet/logo-easywallet.png') center/contain no-repeat;
                background-size: 3.6rem;
            }
        }
    }

    @media (min-width: ${props => props.theme.bps.md}) {
        .logo-img-container {
            height: 4rem;
            width: 8rem;
            background: url('/images/easywallet/logo-easywallet.png') center/contain no-repeat;
            background-size: 8rem;
        }
    }
`

const MobileMenuButton = styled.button`
    width: 2.25rem;
    height: 2rem;

    background: url('/images/icons/menu-hamburger-ew.png') center/cover no-repeat;
    background-size: 2.8rem;

    &.menu-open {
        background: url('/images/icons/menu-hamburger-open.svg') center/cover no-repeat;
    }

    @media (min-width: ${props => props.theme.bps.md}) {
        display: none;
    }
`

const LogoContainer = styled.div`
    @media (min-width: ${props => props.theme.bps.md}) {
        display: none;
    }
    position: relative;
    height: 2.375rem;
    width: 10rem;
}
`

export { AuthContainer, HeaderLogo, MobileMenuButton, LogoContainer }
